import request from '../../../../../../helpers/request';

const key = (requestId) => ['request_by_id', requestId];

const fetchRequest = async ({ queryKey }) => {
  const [_, requestId] = queryKey;

  const res = await request.get(
    `/Request`,
    { requestId },
    'Не удалось получить обновленную заявку. Обновите страницу'
  );

  return res?.[0];
};

export const fetchRequestbyId = ({ queryClient, requestId }) =>
  queryClient.fetchQuery(key(requestId), fetchRequest);
